import { Route, Routes, useParams } from 'react-router-dom';

import { useJourneyEnhancedNavigation } from '@/store/v2/journeys/useJourneyEnhancedNavigation';
import {
  LockedLearningWarningModal,
  useLockedLearningWarningModalProps,
} from '@/administration/pages/Journey/common/modals/LockedLearningWarningModal';
import { PracticalAssessmentView } from '@/features/course/learner/pages/PracticalAssessmentView';
import { LayoutWrapper } from '@/component/App/component/LayoutWrapper/LayoutWrapper';
import { PracticalAssessmentStart } from '@/features/course/learner/pages/PracticalAssessmentStart';
import { usePracticalAssessmentViewer } from '@/features/course/learner/hooks/usePracticalAssessmentViewer';

export const PracticalAssessment = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();

  const parsedSurveyId = id ? parseInt(id) : NaN;

  const props = usePracticalAssessmentViewer(Number(id));

  const { currentItem, journeyTitle, journeyId, nextItem, allUpcomingItemsLocked, allUpcomingItemsUnlockAt } =
    useJourneyEnhancedNavigation({
      id: parsedSurveyId,
    });

  const learningLockedModalProps = useLockedLearningWarningModalProps({
    parentJourneyId: journeyId,
    parentJourneyTitle: journeyTitle,
    isCurrentItemLock: currentItem?.isLocked,
  });

  return (
    <>
      {learningLockedModalProps && <LockedLearningWarningModal {...learningLockedModalProps} />}
      <Routes>
        <Route
          path="/"
          element={
            <LayoutWrapper>
              <PracticalAssessmentStart
                {...props}
                nextItem={nextItem || undefined}
                allUpcomingItemsLocked={allUpcomingItemsLocked}
                allUpcomingItemsUnlockAt={allUpcomingItemsUnlockAt}
              />
            </LayoutWrapper>
          }
        />
        <Route path="/view/*" element={<PracticalAssessmentView {...props} />} />
      </Routes>
    </>
  );
};
